import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const GeneratePackageIDRBAC = {
  pageID: 'a16e546808cebe3c0bc16f2df7cf535b',
  elementID: {
    ViewPage: '2cce2ff699f4747fe6d3be1b44b7d889',
    GeneratePackageID: '1abf3914479bd94198053c2e9364853b',
    Reprint: 'db2b63754a18e965faa53df3729590ba',
    ActionViewDetail: '52186af9f2ae7f5dea341dc7c61c788d',
  },
} as const

export const useRBACGeneratePackageIDPage = createUseRBAC(GeneratePackageIDRBAC.elementID)

export type UseRBACGeneratePackageIDPageType = ReturnType<typeof useRBACGeneratePackageIDPage>
